/**
 * 运输单状态
 */
export const ConstantsTES = {
    TASK_STATUS_NEW: '00', // 创建
    TASK_STATUS_ROWOFCARS: '10', // 已排车
    TASK_STATUS_SHUNTING: '20', // 已调车
    TASK_STATUS_THECAR: '30', // 已到车
    TASK_STATUS_LOADING: '40', // 已装货
    TASK_STATUS_INTRANSIT: '50', // 在途
    TASK_STATUS_HANG: '100', // 挂起
    TASK_STATUS_REVOKE: '110' // 撤销（作废）
};
/**
 * 运输单状态
 */
export const ConstantsDS = {
    DO_STATUS_ON_ORDER: '30' // 在途
};
/**
 * 移交单状态
 */
export const ConstantsTS = {
    TANSFER_STATUS_REJECT: '30' // 已打回
};